<template lang="pug">
.dropdown-list.dropdown-menu.dropdown-menu-right.shadow.animated--grow-in()
  h6.dropdown-header
    | Alerts Center
  a.dropdown-item.d-flex.align-items-center(href='')
    .mr-3
      .icon-circle.bg-primary
        i.fas.fa-file-alt.text-white
    div
      .small.text-gray-500 December 12, 2019
      span.font-weight-bold A new monthly report is ready to download!
  a.dropdown-item.d-flex.align-items-center(href='')
    .mr-3
      .icon-circle.bg-success
        i.fas.fa-donate.text-white
    div
      .small.text-gray-500 December 7, 2019
      |                     $290.29 has been deposited into your account!
  a.dropdown-item.d-flex.align-items-center(href='')
    .mr-3
      .icon-circle.bg-warning
        i.fas.fa-exclamation-triangle.text-white
    div
      .small.text-gray-500 December 2, 2019
      |                     Spending Alert: We've noticed unusually high spending for your account.
  a.dropdown-item.text-center.small.text-gray-500(href='') Show All Alerts
</template>

<script>
export default {
  name: 'DashboardNavNotifications',
  props: {
    notifications: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dropdown-list{
  right:20px;
}
.dropdown-menu{
  display:block;
}
</style>
